import getTokenForOds from './getTokenForOds';
import addDiagnosticsToOdsSession from '../services/addDiagnosticsToOdsSession';
import createOdsDiagnosticsSession from '../services/createOdsDiagnosticsSession';
import * as FeedbackConstants from '../FeedbackConstants';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import { OdsDiagnosticSessionResponse } from '../schema/OdsDiagnosticSessionResponse';

export default async function sendFeedbackToOds(
    donationJson: Object,
    responseText: string,
    responseCategories: string[]
): Promise<string> {
    //Get a token for getting authenticated againt ODS
    const token = await getTokenForOds();

    if (token) {
        //Create a diagnostics session
        let diagnosticResponse = await createOdsDiagnosticsSession(
            {
                Symptom: FeedbackConstants.ODSSYMPTOMNAME,
                ProblemStatement: responseText,
                Tags: responseCategories,
            },
            token
        );

        if (isSuccessStatusCode(diagnosticResponse.status)) {
            let responseJson: OdsDiagnosticSessionResponse = await diagnosticResponse.json();

            // Upload the json payload to the diagnostic session
            let innerResponse = await addDiagnosticsToOdsSession(
                {
                    Parameters: [
                        {
                            Name: FeedbackConstants.ODSJSONPAYLOADNAME,
                            Value: donationJson,
                            ComplianceClassification: FeedbackConstants.ODSCOMPLIANCECLASSIFICATION,
                        },
                    ],
                },
                token,
                responseJson.DiagnosticSessionId
            );
            if (isSuccessStatusCode(innerResponse.status)) {
                return responseJson.DiagnosticSessionId;
            } else {
                return (
                    responseJson.DiagnosticSessionId +
                    ' : Call to v1/diagnosis failed with a ' +
                    innerResponse.status
                );
            }
        } else {
            return 'Call to v1/diagnosticsession failed with a ' + diagnosticResponse.status;
        }
    } else {
        return 'Failed to get the token for ODS';
    }
}
